import React from 'react';

export const InvestigateContext = React.createContext({});
